/**
 * Editor de fotos operacional (spec 0082 / ADR-052).
 * 1 camada editável (upload ou promote de máscara) + máscaras-guia.
 * Pipeline 3:4 1650×2200 forkado do lab 0045.
 */
(function () {
  'use strict';

  var OUT_W = 1650;
  var OUT_H = 2200;
  var VIEW_W = 550;
  var VIEW_H = 734;
  var THUMB_W = 72;
  var THUMB_H = 96;
  var EDGE_MARGIN = 0.02;
  var EDGE_THRESH = 36;
  var SHADOW_THRESH = 78;
  var DARK_LUMA = 90;
  // Sombra de contato larga (camurça/couro fosco): mancha quase neutra (chroma baixo)
  // que se espalha bem além do SHADOW_THRESH antes de sumir no fundo. Piso de luma
  // alto o bastante pra nunca engolir o corpo de um produto escuro/preto (couro preto
  // fica bem abaixo de SHADOW_WIDE_MIN_LUMA; calibrado com fotos reais de camurça
  // chocolate/taupe — ver conversa da spec 0082).
  var SHADOW_WIDE_MAX_CHROMA = 26;
  var SHADOW_WIDE_MIN_LUMA = 130;
  var SHADOW_WIDE_MAX_LUMA = 235;
  var SHADOW_WIDE_MAX_DIST = 220;
  var OVERLAY_ALPHA = 0.38;
  var DEFAULT_BOTTOM = 0.17;
  var DEFAULT_FEATHER_PX = 22;

  var REF_PROFILES = {
    default: { bottomGap: DEFAULT_BOTTOM, contentH: 0.52, label: 'default' },
    pochete: { bottomGap: DEFAULT_BOTTOM, contentH: 0.22, label: 'pochete' },
    alca: { bottomGap: DEFAULT_BOTTOM, contentH: 0.35, label: 'alca-avulsa' },
    nicole: { bottomGap: DEFAULT_BOTTOM, contentH: 0.675, label: 'nicole/medium' },
    nena: { bottomGap: DEFAULT_BOTTOM, contentH: 0.42, label: 'nena' },
    eva: { bottomGap: DEFAULT_BOTTOM, contentH: 0.55, label: 'eva/tote' },
    bolsa_pequena: { bottomGap: DEFAULT_BOTTOM, contentH: 0.55, label: 'bolsa pequena' },
    bolsa_grande: { bottomGap: DEFAULT_BOTTOM, contentH: 0.55, label: 'tote/grande' },
    carteira: { bottomGap: DEFAULT_BOTTOM, contentH: 0.24, label: 'carteira/acessorio' },
    // Variantes de tamanho de um mesmo modelo-base (ex.: Bolsa Ana Giga vs.
    // Bolsa Ana Pequena) são modelos separados no editor, então nunca se
    // comparam entre si na correção automática — sem um contentH próprio
    // pra cada tamanho, as duas caíam no fallback genérico (bolsa_pequena,
    // 0.55) e a bolsa mini ficava ocupando o mesmo tanto do quadro que a
    // giga, apagando a diferença real de tamanho que a foto original
    // mostrava (medido nos originais: giga ~58-64%, mini ~37-38%).
    bolsa_giga: { bottomGap: DEFAULT_BOTTOM, contentH: 0.61, label: 'bolsa giga' },
    bolsa_mini: { bottomGap: DEFAULT_BOTTOM, contentH: 0.38, label: 'bolsa mini/pequena' },
  };

  var section = document.querySelector('[data-gm-editor]');
  var dataEl = document.querySelector('[data-gm-editor-data]');
  var modelosEl = document.querySelector('[data-gm-editor-modelos]');
  if (!section || !dataEl) return;

  var canvas = section.querySelector('[data-gm-editor-canvas]');
  var layersEl = section.querySelector('[data-gm-editor-layers]');
  var hintEl = section.querySelector('[data-gm-editor-hint]');
  var statusEl = section.querySelector('[data-gm-editor-status]');
  var modeloLabel = section.querySelector('[data-gm-editor-modelo-label]');
  var zoomInp = section.querySelector('[data-gm-editor-zoom]');
  var zoomOut = section.querySelector('[data-gm-editor-zoom-out]');
  var btnAutoAlign = section.querySelector('[data-gm-editor-auto-align]');
  var btnBbox = section.querySelector('[data-gm-editor-bbox]');
  var btnCenter = section.querySelector('[data-gm-editor-center]');
  var btnReset = section.querySelector('[data-gm-editor-reset]');
  var btnExport = null; // recriado em renderLayers, abaixo do slot editável
  var btnEyeMaster = null; // recriado em renderLayers
  var btnLockMaster = null; // recriado em renderLayers
  var btnOpenModelo = section.querySelector('[data-gm-editor-open-modelo]');
  var modeloModal = section.querySelector('[data-gm-editor-modelo-modal]');
  var modeloList = section.querySelector('[data-gm-editor-modelo-list]');
  var modeloSearch = section.querySelector('[data-gm-editor-modelo-search]');
  var btnModeloClose = section.querySelector('[data-gm-editor-modelo-close]');
  var fileInput = section.querySelector('[data-gm-editor-file]');
  var asideEl = section.querySelector('[data-gm-editor-aside]');

  if (canvas) {
    canvas.width = VIEW_W;
    canvas.height = VIEW_H;
  }

  var products = [];
  var modelosCatalog = [];
  try {
    products = JSON.parse(dataEl.textContent || '[]');
  } catch (e) {
    if (statusEl) statusEl.textContent = 'JSON inválido.';
    return;
  }
  try {
    if (modelosEl) modelosCatalog = JSON.parse(modelosEl.textContent || '[]');
  } catch (e2) {
    modelosCatalog = [];
  }

  function titleTokens(title) {
    return String(title || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function commonWordPrefix(titles) {
    var lists = (titles || []).map(titleTokens).filter(function (t) {
      return t.length;
    });
    if (!lists.length) return '';
    var common = [];
    var i;
    for (i = 0; i < lists[0].length; i++) {
      var word = lists[0][i];
      var low = word.toLowerCase();
      var ok = lists.every(function (toks) {
        return toks[i] && toks[i].toLowerCase() === low;
      });
      if (!ok) break;
      common.push(word);
    }
    if (common.length) return common.join(' ');
    return lists[0].slice(0, Math.min(3, lists[0].length)).join(' ');
  }

  function handleizeLabel(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function clusterByTitlePrefix(list) {
    var n = list.length;
    var parent = [];
    var i;
    var j;
    for (i = 0; i < n; i++) parent[i] = i;

    function find(x) {
      while (parent[x] !== x) {
        parent[x] = parent[parent[x]];
        x = parent[x];
      }
      return x;
    }
    function union(a, b) {
      a = find(a);
      b = find(b);
      if (a !== b) parent[b] = a;
    }

    function prefixLen(a, b) {
      var ta = titleTokens(a.title);
      var tb = titleTokens(b.title);
      var k = 0;
      while (k < ta.length && k < tb.length && ta[k].toLowerCase() === tb[k].toLowerCase()) {
        k += 1;
      }
      return k;
    }

    for (i = 0; i < n; i++) {
      for (j = i + 1; j < n; j++) {
        var len = prefixLen(list[i], list[j]);
        var minLen = Math.min(titleTokens(list[i].title).length, titleTokens(list[j].title).length);
        // Exige pelo menos 2 palavras em comum no início; evita juntar "Bolsa Dani" + "Bolsa Fefa".
        // Se o título curto tem só 2-3 palavras, exige prefixo == minLen - 1 (sobra a cor).
        var need = minLen <= 3 ? Math.max(2, minLen - 1) : 2;
        if (len >= need) union(i, j);
      }
    }

    var buckets = {};
    for (i = 0; i < n; i++) {
      var root = find(i);
      if (!buckets[root]) buckets[root] = [];
      buckets[root].push(list[i]);
    }

    Object.keys(buckets).forEach(function (root) {
      var items = buckets[root];
      var label = commonWordPrefix(
        items.map(function (p) {
          return p.title;
        })
      );
      var key = handleizeLabel(label) || 'grupo-' + root;
      items.forEach(function (p) {
        p.modelo = key;
        p.modeloLabel = label || p.title || key;
      });
    });
  }

  function applyModeloLabelsFromTitles(list) {
    var byKey = {};
    list.forEach(function (p) {
      var key = p.modelo || '_sem-modelo';
      if (!byKey[key]) byKey[key] = [];
      byKey[key].push(p);
    });
    Object.keys(byKey).forEach(function (key) {
      var items = byKey[key];
      var label = commonWordPrefix(
        items.map(function (p) {
          return p.title;
        })
      );
      if (!label) return;
      items.forEach(function (p) {
        p.modeloLabel = label;
      });
    });
  }

  function resolveProductModelos(list, catalog) {
    var byId = {};
    var byHandle = {};
    (catalog || []).forEach(function (m) {
      if (!m) return;
      if (m.id != null && m.id !== '') byId[String(m.id)] = m;
      if (m.handle) byHandle[m.handle] = m;
    });

    var idHits = 0;
    list.forEach(function (p) {
      var meta = null;
      if (p.modeloId != null && p.modeloId !== '' && byId[String(p.modeloId)]) {
        meta = byId[String(p.modeloId)];
      } else if (p.modelo && byHandle[p.modelo]) {
        meta = byHandle[p.modelo];
      } else if (p.modelo && String(p.modelo).indexOf('gid://shopify/Metaobject/') === 0) {
        meta = byId[String(p.modelo).split('/').pop()] || null;
      }

      if (meta) {
        p.modelo = meta.handle || p.modelo;
        p.modeloLabel = meta.nome || meta.handle || '';
        idHits += 1;
      } else if (p.modeloId != null && p.modeloId !== '') {
        p.modelo = 'mo-' + String(p.modeloId);
        p.modeloLabel = '';
        idHits += 1;
      } else if (p.modelo && String(p.modelo).indexOf('gid://') !== 0 && p.modelo !== '') {
        p.modeloLabel = p.modeloLabel || '';
      } else {
        p.modelo = '';
        p.modeloLabel = '';
      }
    });

    // Sem metacampo confiável (ou tudo no mesmo balde): agrupa pelo título.
    var uniqueKeys = {};
    list.forEach(function (p) {
      if (p.modelo) uniqueKeys[p.modelo] = true;
    });
    var keyCount = Object.keys(uniqueKeys).length;
    var needTitleCluster =
      idHits === 0 ||
      keyCount <= 1 ||
      (list.length >= 10 && keyCount <= 2);

    if (needTitleCluster) {
      clusterByTitlePrefix(list);
    } else {
      applyModeloLabelsFromTitles(list);
    }

    list.forEach(function (p) {
      if (!p.modelo) {
        p.modelo = handleizeLabel(p.title) || '_sem-modelo';
      }
      if (!p.modeloLabel) {
        p.modeloLabel = commonWordPrefix([p.title]) || p.title || p.modelo;
      }
    });
  }

  function productCaption(p, fallback) {
    var name = (p && (p.title || p.cor)) || fallback || '';
    if (p && p.draft) name += ' · rascunho';
    return name;
  }

  var settings = {
    fill: 'solid',
    feather: true,
    featherPx: DEFAULT_FEATHER_PX,
  };

  var modeloCatalog = [];
  var analyzedByModelo = {};
  var loadToken = 0;

  var state = {
    modelo: null,
    masks: [],
    editable: null,
    selectedGuideId: null,
    masksMasterVisible: true,
    bboxMode: false,
    lay: null,
    drag: null,
    bboxDrag: null,
  };

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function luma(r, g, b) {
    return 0.299 * r + 0.587 * g + 0.114 * b;
  }

  function colorDist(r1, g1, b1, r2, g2, b2) {
    var dr = r1 - r2;
    var dg = g1 - g2;
    var db = b1 - b2;
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }

  function escapeAttr(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function setStatus(msg) {
    if (statusEl) statusEl.textContent = msg || '';
  }

  function setHint(msg) {
    if (hintEl) hintEl.textContent = msg || '';
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(new Error('fail ' + url));
      };
      img.src = url;
    });
  }

  function profileForModelo(modelo) {
    var m = String(modelo || '').toLowerCase();
    if (/alca-avulsa|alca_avulsa|alca avulsa/.test(m)) return REF_PROFILES.alca;
    if (/nicole/.test(m)) return REF_PROFILES.nicole;
    if (/nena/.test(m)) return REF_PROFILES.nena;
    if (/eva/.test(m)) return REF_PROFILES.eva;
    if (/pochete/.test(m) || (/rafa/.test(m) && !/alca/.test(m))) return REF_PROFILES.pochete;
    if (/carteira|guarda-cart|guarda-chave|cinto|necessaire/.test(m)) return REF_PROFILES.carteira;
    // Variantes de tamanho: checadas antes do fallback genérico "bolsa/ana"
    // pra não perder a diferença real de tamanho entre giga/mini do mesmo
    // modelo-base (ver comentário em REF_PROFILES). Escopo restrito a
    // "ana-giga"/"ana-pequena" de propósito — "pequena" sozinho aparece
    // também em modelos como bolsa-dani-pequena, onde não é uma variante de
    // tamanho e sim parte fixa do nome do produto (medido nos originais:
    // ~50% de quadro, igual ao padrão normal — trocar o perfil ali ficaria
    // errado).
    if (/\bana-giga\b/.test(m)) return REF_PROFILES.bolsa_giga;
    if (/\bana-pequena\b/.test(m)) return REF_PROFILES.bolsa_mini;
    if (/tote|vanessa|van\b|grande|maxi/.test(m)) return REF_PROFILES.bolsa_grande;
    if (/bolsa|dani|ana|fefa|lena|natasha/.test(m)) return REF_PROFILES.bolsa_pequena;
    return REF_PROFILES.default;
  }

  function sampleEdgeColor(ctx, w, h) {
    var data = ctx.getImageData(0, 0, w, h).data;
    var mx = Math.max(1, Math.floor(w * EDGE_MARGIN));
    var my = Math.max(1, Math.floor(h * EDGE_MARGIN));
    var sumR = 0;
    var sumG = 0;
    var sumB = 0;
    var count = 0;

    function sample(px, py) {
      var i = (py * w + px) * 4;
      var a = data[i + 3];
      if (a < 20) {
        sumR += 246;
        sumG += 246;
        sumB += 246;
        count += 1;
        return;
      }
      var r = data[i];
      var g = data[i + 1];
      var b = data[i + 2];
      if (luma(r, g, b) < DARK_LUMA) return;
      sumR += r;
      sumG += g;
      sumB += b;
      count += 1;
    }

    var x;
    var y;
    for (y = 0; y < my; y++) for (x = 0; x < w; x++) sample(x, y);
    for (y = h - my; y < h; y++) for (x = 0; x < w; x++) sample(x, y);
    for (y = my; y < h - my; y++) {
      for (x = 0; x < mx; x++) sample(x, y);
      for (x = w - mx; x < w; x++) sample(x, y);
    }
    if (!count) return { r: 246, g: 246, b: 246 };
    return {
      r: Math.round(sumR / count),
      g: Math.round(sumG / count),
      b: Math.round(sumB / count),
    };
  }

  /**
   * opts.wideShadow (default off) liga o 3º nível de detecção de sombra
   * (mancha larga quase neutra de camurça/couro fosco). bbox "plain" (sem
   * wideShadow) fica só como fallback (analysis.bbox); o resto do pipeline
   * usa a versão wideShadow por padrão (ver effectiveBbox) pra não confundir
   * "sombra de contato mais forte nessa foto" com "produto fora do padrão".
   */
  function findContentBboxFlood(ctx, w, h, edge, opts) {
    var wideShadow = !!(opts && opts.wideShadow);
    var data = ctx.getImageData(0, 0, w, h).data;
    var bg = new Uint8Array(w * h);
    var stack = new Int32Array(w * h);
    var sp = 0;

    function isBgPixel(idx) {
      var i = idx * 4;
      var a = data[i + 3];
      if (a < 20) return true;
      var r = data[i];
      var g = data[i + 1];
      var b = data[i + 2];
      var dist = colorDist(r, g, b, edge.r, edge.g, edge.b);
      if (dist <= EDGE_THRESH) return true;
      var maxc = Math.max(r, g, b);
      var minc = Math.min(r, g, b);
      var chroma = maxc - minc;
      var L = luma(r, g, b);
      if (chroma < 28 && L >= 145 && L <= 220 && dist <= SHADOW_THRESH) return true;
      if (chroma < 22 && L >= 210 && dist <= SHADOW_THRESH + 20) return true;
      if (
        wideShadow &&
        chroma <= SHADOW_WIDE_MAX_CHROMA &&
        L >= SHADOW_WIDE_MIN_LUMA &&
        L <= SHADOW_WIDE_MAX_LUMA &&
        dist <= SHADOW_WIDE_MAX_DIST
      ) {
        return true;
      }
      return false;
    }

    function push(idx) {
      if (idx < 0 || idx >= w * h || bg[idx]) return;
      if (!isBgPixel(idx)) return;
      bg[idx] = 1;
      stack[sp++] = idx;
    }

    var x;
    var y;
    for (x = 0; x < w; x++) {
      push(x);
      push((h - 1) * w + x);
    }
    for (y = 0; y < h; y++) {
      push(y * w);
      push(y * w + (w - 1));
    }

    while (sp > 0) {
      var cur = stack[--sp];
      var cx = cur % w;
      var cy = (cur / w) | 0;
      if (cx > 0) push(cur - 1);
      if (cx < w - 1) push(cur + 1);
      if (cy > 0) push(cur - w);
      if (cy < h - 1) push(cur + w);
    }

    var minX = w;
    var minY = h;
    var maxX = -1;
    var maxY = -1;
    var i;
    for (i = 0; i < w * h; i++) {
      if (bg[i]) continue;
      if (data[i * 4 + 3] < 20) continue;
      x = i % w;
      y = (i / w) | 0;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
    }

    if (maxX < 0) return { x: 0, y: 0, w: w, h: h };
    var pad = Math.round(Math.min(w, h) * 0.015);
    minX = clamp(minX - pad, 0, w - 1);
    minY = clamp(minY - pad, 0, h - 1);
    maxX = clamp(maxX + pad, 0, w - 1);
    maxY = clamp(maxY + pad, 0, h - 1);
    return { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
  }

  function analyzeImage(img) {
    var w = img.naturalWidth || img.width;
    var h = img.naturalHeight || img.height;
    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);
    var edge = sampleEdgeColor(ctx, w, h);
    var bbox = findContentBboxFlood(ctx, w, h, edge);
    // Sombra-tolerante calculada uma vez aqui (mesmo critério do botão
    // Correção automática) — vira o bbox padrão em effectiveBbox(). Barato:
    // mesma imagem/edge já decodificados.
    var bboxWide = findContentBboxFlood(ctx, w, h, edge, { wideShadow: true });
    return { canvas: c, edge: edge, bbox: bbox, bboxWide: bboxWide, w: w, h: h };
  }

  /**
   * Recalcula o bbox de um item já analisado usando o critério tolerante a
   * sombra (spec 0082). Chamado só pelo botão Correção automática — reusa o
   * canvas/edge já em cache, não decodifica a imagem de novo.
   */
  function shadowAwareBbox(item) {
    var src = item.analysis;
    var ctx = src.canvas.getContext('2d', { willReadFrequently: true });
    return findContentBboxFlood(ctx, src.w, src.h, src.edge, { wideShadow: true });
  }

  function ensureEdit(item) {
    if (!item.edit) {
      item.edit = { scaleMul: 1, offsetX: 0, offsetY: 0, bboxOverride: null };
    }
    return item.edit;
  }

  /**
   * Bbox efetivo de um item: override manual (Refinar área / Correção
   * automática) se existir, senão a detecção tolerante a sombra
   * (analysis.bboxWide). Usado em todo o pipeline — posicionamento
   * (layoutParams), escala compartilhada do grupo (sharedScaleForGroup) e
   * alerta de silhueta — de propósito o mesmo bbox em todo lugar: uma sombra
   * de contato mais forte numa foto não deve, sozinha, mudar como ela é
   * posicionada/escalada nem acusar "fora do padrão" se o produto em si está
   * alinhado com o grupo. Antes essas três coisas usavam bboxes diferentes
   * (plain vs. wideShadow) e a escala compartilhada ficava inconsistente
   * sempre que só um item do grupo tinha sido corrigido.
   */
  function effectiveBbox(item) {
    if (item.edit && item.edit.bboxOverride) return item.edit.bboxOverride;
    return (item.analysis && item.analysis.bboxWide) || item.analysis.bbox;
  }

  function scaleBbox(bbox, sx, sy) {
    return {
      x: Math.round(bbox.x * sx),
      y: Math.round(bbox.y * sy),
      w: Math.max(1, Math.round(bbox.w * sx)),
      h: Math.max(1, Math.round(bbox.h * sy)),
    };
  }

  function layoutParams(item, sharedScale, bottomGap, outW, outH) {
    outW = outW == null ? OUT_W : outW;
    outH = outH == null ? OUT_H : outH;
    var src = item.analysis;
    var bbox = effectiveBbox(item);
    var scaleMul = (item.edit && item.edit.scaleMul) || 1;
    var ox = ((item.edit && item.edit.offsetX) || 0) * (outW / OUT_W);
    var oy = ((item.edit && item.edit.offsetY) || 0) * (outH / OUT_H);
    var scale = sharedScale * scaleMul;
    var drawW = src.w * scale;
    var drawH = src.h * scale;
    var bboxBottom = (bbox.y + bbox.h) * scale;
    var bboxLeft = bbox.x * scale;
    var bboxW = bbox.w * scale;
    var dy = outH * (1 - bottomGap) - bboxBottom + oy;
    var dx = (outW - bboxW) / 2 - bboxLeft + ox;
    return { scale: scale, dx: dx, dy: dy, drawW: drawW, drawH: drawH, bbox: bbox };
  }

  function drawFeathered(ctx, srcCanvas, dx, dy, drawW, drawH, edge, featherPx, outW, outH) {
    var tmp = document.createElement('canvas');
    tmp.width = outW;
    tmp.height = outH;
    var tctx = tmp.getContext('2d', { willReadFrequently: true });
    tctx.imageSmoothingEnabled = true;
    tctx.imageSmoothingQuality = 'high';
    tctx.drawImage(srcCanvas, dx, dy, drawW, drawH);
    var imgData = tctx.getImageData(0, 0, outW, outH);
    var d = imgData.data;
    var softMax = EDGE_THRESH + Math.max(8, featherPx * 2);
    var x;
    var y;
    for (y = 0; y < outH; y++) {
      for (x = 0; x < outW; x++) {
        var i = (y * outW + x) * 4;
        if (d[i + 3] < 10) continue;
        var r = d[i];
        var g = d[i + 1];
        var b = d[i + 2];
        var distBg = colorDist(r, g, b, edge.r, edge.g, edge.b);
        if (distBg >= softMax) continue;
        var t = clamp(distBg / softMax, 0, 1);
        t = t * t;
        d[i] = Math.round(edge.r + (r - edge.r) * t);
        d[i + 1] = Math.round(edge.g + (g - edge.g) * t);
        d[i + 2] = Math.round(edge.b + (b - edge.b) * t);
      }
    }
    tctx.putImageData(imgData, 0, 0);
    ctx.drawImage(tmp, 0, 0);
  }

  function processTo34(item, sharedScale, bottomGap, opts, outW, outH) {
    outW = outW == null ? OUT_W : outW;
    outH = outH == null ? OUT_H : outH;
    var src = item.analysis;
    var out = document.createElement('canvas');
    out.width = outW;
    out.height = outH;
    var ctx = out.getContext('2d');
    var edge = src.edge;
    var lay = layoutParams(item, sharedScale, bottomGap, outW, outH);

    ctx.fillStyle = 'rgb(' + edge.r + ',' + edge.g + ',' + edge.b + ')';
    ctx.fillRect(0, 0, outW, outH);

    if (opts.feather && opts.featherPx > 0) {
      drawFeathered(ctx, src.canvas, lay.dx, lay.dy, lay.drawW, lay.drawH, edge, opts.featherPx, outW, outH);
    } else {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(src.canvas, lay.dx, lay.dy, lay.drawW, lay.drawH);
    }
    return out;
  }

  function scaleToView(sharedScale, outW) {
    return sharedScale * (outW / OUT_W);
  }

  function processCacheKey(item, sharedScale, bottomGap, opts, outW, outH) {
    var e = item.edit || {};
    var bb = e.bboxOverride;
    return [
      item.id,
      sharedScale,
      bottomGap,
      outW,
      outH,
      opts.fill,
      opts.feather ? 1 : 0,
      opts.featherPx || 0,
      e.scaleMul || 1,
      e.offsetX || 0,
      e.offsetY || 0,
      bb ? [bb.x, bb.y, bb.w, bb.h].join(',') : '-',
    ].join('|');
  }

  function getProcessed(item, sharedScale, bottomGap, opts, outW, outH) {
    var key = processCacheKey(item, sharedScale, bottomGap, opts, outW, outH);
    if (!item._procCache) item._procCache = {};
    if (item._procCache[key]) return item._procCache[key];
    var c = processTo34(item, sharedScale, bottomGap, opts, outW, outH);
    item._procCache[key] = c;
    var keys = Object.keys(item._procCache);
    if (keys.length > 6) {
      keys.slice(0, keys.length - 6).forEach(function (k) {
        delete item._procCache[k];
      });
    }
    return c;
  }

  function canvasToUrl(c, q) {
    try {
      return c.toDataURL('image/jpeg', q == null ? 0.92 : q);
    } catch (e) {
      return '';
    }
  }

  function sharedScaleForGroup(items, contentH, bottomGap, outW, outH) {
    outW = outW == null ? OUT_W : outW;
    outH = outH == null ? OUT_H : outH;
    var maxH = 0;
    var maxW = 0;
    items.forEach(function (it) {
      var bb = effectiveBbox(it);
      if (bb.h > maxH) maxH = bb.h;
      if (bb.w > maxW) maxW = bb.w;
    });
    var scaleH = (outH * contentH) / Math.max(maxH, 1);
    var scaleW = (outW * 0.92) / Math.max(maxW, 1);
    var scale = Math.min(scaleH, scaleW);
    items.forEach(function (it) {
      var bh = effectiveBbox(it).h * scale;
      var maxTop = outH * (1 - bottomGap) - bh;
      if (maxTop < outH * 0.02) {
        scale = Math.min(scale, (outH * (1 - bottomGap - 0.02)) / effectiveBbox(it).h);
      }
    });
    return scale;
  }

  function scaleFromPreview(loScale, loAnalysis, hiAnalysis) {
    var loW = Math.max((loAnalysis && loAnalysis.w) || 1, 1);
    var hiW = Math.max((hiAnalysis && hiAnalysis.w) || 1, 1);
    return loScale * (loW / hiW);
  }

  function modeloDisplayName(entryOrKey, product) {
    if (product && product.modeloLabel) return product.modeloLabel;
    var key = typeof entryOrKey === 'string' ? entryOrKey : entryOrKey && entryOrKey.modelo;
    if (entryOrKey && entryOrKey.label) return entryOrKey.label;
    if (!key || key === '_sem-modelo') return 'Sem modelo';
    if (String(key).indexOf('gid://') === 0 || String(key).indexOf('mo-') === 0) {
      return product && product.title ? commonWordPrefix([product.title]) : 'Modelo';
    }
    return String(key).replace(/-/g, ' ');
  }

  function buildModeloCatalog() {
    var map = {};
    products.forEach(function (p) {
      var key = p.modelo || '_sem-modelo';
      if (String(key).indexOf('gid://') === 0) key = '_sem-modelo';
      if (!map[key]) {
        map[key] = {
          modelo: key,
          label: p.modeloLabel || modeloDisplayName(key, p),
          products: [],
          thumb: p.thumbUrl || p.cardUrl || p.mainUrl,
        };
      } else if (p.modeloLabel) {
        map[key].label = p.modeloLabel;
      }
      map[key].products.push(p);
    });
    // Relabel each group from common title words (source of truth).
    Object.keys(map).forEach(function (key) {
      var label = commonWordPrefix(
        map[key].products.map(function (p) {
          return p.title;
        })
      );
      if (label) {
        map[key].label = label;
        map[key].products.forEach(function (p) {
          p.modeloLabel = label;
        });
      }
    });
    return Object.keys(map)
      .sort(function (a, b) {
        if (a === '_sem-modelo') return 1;
        if (b === '_sem-modelo') return -1;
        var la = (map[a].label || a).toLowerCase();
        var lb = (map[b].label || b).toLowerCase();
        return la.localeCompare(lb, 'pt-BR');
      })
      .map(function (key) {
        return map[key];
      });
  }

  function makeItem(product, img, analysis, opts) {
    opts = opts || {};
    return {
      id: opts.id || product.handle,
      product: product,
      img: img,
      analysis: analysis,
      visible: opts.visible !== false,
      locked: opts.locked !== false,
      source: opts.source || 'mask',
      objectUrl: opts.objectUrl || null,
      edit: { scaleMul: 1, offsetX: 0, offsetY: 0, bboxOverride: null },
      _procCache: {},
      _thumbUrls: {},
    };
  }

  function findMaskById(id) {
    if (!id) return null;
    for (var i = 0; i < state.masks.length; i++) {
      if (state.masks[i].id === id) return state.masks[i];
    }
    return null;
  }

  function allMasksLocked() {
    if (!state.masks.length) return true;
    return state.masks.every(function (m) {
      return m.locked !== false;
    });
  }

  /**
   * Alvo de pan/zoom/refinar/export:
   * - guia destrancada selecionada (modo livre), senão
   * - slot editável.
   */
  function getEditTarget() {
    if (state.selectedGuideId) {
      var m = findMaskById(state.selectedGuideId);
      if (m && m.locked === false && state.masksMasterVisible && m.visible) {
        return m;
      }
    }
    return state.editable || null;
  }

  function guideItems() {
    var items = state.masks.filter(function (m) {
      return state.masksMasterVisible && m.visible;
    });
    return items;
  }

  function layoutScaleItems() {
    var profile = profileForModelo(state.modelo);
    var bottomGap = profile.bottomGap;
    var contentH = profile.contentH;
    // Escala das guias NÃO inclui a editável: upload/export 1650×2200 tem bbox
    // em px bem maior que as mains ~1200 e derrubava sharedScale (máscaras minúsculas).
    var maskItems = state.masks.slice();
    var guideScale = maskItems.length
      ? sharedScaleForGroup(maskItems, contentH, bottomGap)
      : null;
    var editScale = null;
    if (state.editable) {
      if (state.editable.source === 'upload' || !maskItems.length) {
        editScale = sharedScaleForGroup([state.editable], contentH, bottomGap);
      } else {
        // Promote de máscara: mesma família de resolução → mantém escala das guias.
        editScale = guideScale;
      }
    }
    var scale = guideScale != null ? guideScale : editScale;
    if (scale == null) return null;
    if (editScale == null) editScale = scale;
    return {
      profile: profile,
      bottomGap: bottomGap,
      contentH: contentH,
      scale: scale,
      editScale: editScale,
    };
  }

  function itemBaseScale(item) {
    if (!state.lay) return 1;
    if (item && state.editable && item === state.editable) {
      return state.lay.editScale != null ? state.lay.editScale : state.lay.scale;
    }
    return state.lay.scale;
  }

  function refreshLay() {
    state.lay = layoutScaleItems();
  }

  function setToolsEnabled(on) {
    var editOn = !!on;
    if (zoomInp) zoomInp.disabled = !editOn;
    if (btnAutoAlign) btnAutoAlign.disabled = !editOn;
    if (btnBbox) btnBbox.disabled = !editOn;
    if (btnCenter) btnCenter.disabled = !editOn;
    if (btnReset) btnReset.disabled = !editOn;
    btnExport = section.querySelector('[data-gm-editor-export]');
    // Export sempre usa o pipeline processado, independente do preview.
    if (btnExport) btnExport.disabled = !on;
  }

  function syncZoomUi() {
    var target = getEditTarget();
    if (!target) {
      if (zoomInp) zoomInp.value = '100';
      if (zoomOut) zoomOut.textContent = '100%';
      return;
    }
    var mul = ensureEdit(target).scaleMul;
    var pct = String(Math.round(mul * 100));
    if (zoomInp) zoomInp.value = pct;
    if (zoomOut) zoomOut.textContent = pct + '%';
  }

  function syncBboxBtn() {
    if (!btnBbox) return;
    btnBbox.classList.toggle('gm-editor__btn--active', !!state.bboxMode);
    btnBbox.setAttribute('aria-pressed', state.bboxMode ? 'true' : 'false');
  }

  function syncLockMaster() {
    btnLockMaster = section.querySelector('[data-gm-editor-lock-master]');
    if (!btnLockMaster) return;
    var locked = allMasksLocked();
    btnLockMaster.disabled = !state.modelo || !state.masks.length;
    btnLockMaster.setAttribute('aria-pressed', locked ? 'true' : 'false');
    btnLockMaster.classList.toggle('is-locked', locked);
    btnLockMaster.title = locked
      ? 'Destrancar todas (edição livre)'
      : 'Trancar todas (só visual)';
  }

  function syncEyeMaster() {
    btnEyeMaster = section.querySelector('[data-gm-editor-eye-master]');
    if (!btnEyeMaster) return;
    var pressed = state.masksMasterVisible;
    btnEyeMaster.disabled = !state.modelo || !state.masks.length;
    btnEyeMaster.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    btnEyeMaster.classList.toggle('is-hidden', !pressed);
  }

  var EYE_SVG_ON =
    '<svg class="gm-editor__ico gm-editor__ico--eye-on" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="1.4" d="M1.5 9s2.8-5 7.5-5 7.5 5 7.5 5-2.8 5-7.5 5S1.5 9 1.5 9z"/>' +
    '<circle cx="9" cy="9" r="2.2" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
  var EYE_SVG_OFF =
    '<svg class="gm-editor__ico gm-editor__ico--eye-off" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="1.4" d="M1.5 9s2.8-5 7.5-5 7.5 5 7.5 5-2.8 5-7.5 5S1.5 9 1.5 9z"/>' +
    '<circle cx="9" cy="9" r="2.2" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
    '<path stroke="currentColor" stroke-width="1.4" d="M3 15 15 3"/></svg>';
  var LOCK_SVG_ON =
    '<svg class="gm-editor__ico gm-editor__ico--lock-on" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">' +
    '<rect x="4.5" y="8" width="9" height="7" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
    '<path fill="none" stroke="currentColor" stroke-width="1.4" d="M6.5 8V6.2a2.5 2.5 0 0 1 5 0V8"/></svg>';
  var LOCK_SVG_OFF =
    '<svg class="gm-editor__ico gm-editor__ico--lock-off" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">' +
    '<rect x="4.5" y="8" width="9" height="7" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
    '<path fill="none" stroke="currentColor" stroke-width="1.4" d="M6.5 8V6.2a2.5 2.5 0 0 1 5 0V4.8"/></svg>';
  var WARN_SVG =
    '<svg class="gm-editor__ico gm-editor__ico--warn" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" d="M8 1.6 15 14H1L8 1.6z"/>' +
    '<path stroke="currentColor" stroke-width="1.4" d="M8 6.2v3.4"/>' +
    '<circle cx="8" cy="11.6" r="0.9" fill="currentColor"/></svg>';

  /**
   * Detecção de silhueta fora do padrão entre as camadas guia (spec 0082).
   * Com < 3 itens não há maioria pra comparar, então não sinaliza nada.
   * Métricas normalizadas pelo próprio quadro de cada foto (área/posição do
   * bbox), não pela escala de saída — assim compara o enquadramento original,
   * que é onde o flood-fill pode ter errado ou a foto ter sido tirada diferente.
   */
  var SILHOUETTE_MIN_ITEMS = 3;
  var SILHOUETTE_Z_THRESHOLD = 3.5;
  var SILHOUETTE_MIN_MAD = { area: 0.008, x: 0.012, y: 0.012 };

  function silhouetteMetrics(item) {
    var bbox = effectiveBbox(item);
    var w = item.analysis.w || 1;
    var h = item.analysis.h || 1;
    return {
      area: (bbox.w * bbox.h) / (w * h),
      cx: (bbox.x + bbox.w / 2) / w - 0.5,
      cy: (bbox.y + bbox.h / 2) / h - 0.5,
    };
  }

  function median(nums) {
    var arr = nums.slice().sort(function (a, b) {
      return a - b;
    });
    var n = arr.length;
    if (!n) return 0;
    var mid = Math.floor(n / 2);
    return n % 2 ? arr[mid] : (arr[mid - 1] + arr[mid]) / 2;
  }

  function modifiedZScores(values, minMad) {
    var med = median(values);
    var mad = median(
      values.map(function (v) {
        return Math.abs(v - med);
      })
    );
    var scale = Math.max(mad, minMad);
    return values.map(function (v) {
      return (0.6745 * (v - med)) / scale;
    });
  }

  function computeSilhouetteAlerts(items) {
    var alerts = {};
    if (!items || items.length < SILHOUETTE_MIN_ITEMS) return alerts;
    var metrics = items.map(silhouetteMetrics);
    var zArea = modifiedZScores(
      metrics.map(function (m) {
        return m.area;
      }),
      SILHOUETTE_MIN_MAD.area
    );
    var zCx = modifiedZScores(
      metrics.map(function (m) {
        return m.cx;
      }),
      SILHOUETTE_MIN_MAD.x
    );
    var zCy = modifiedZScores(
      metrics.map(function (m) {
        return m.cy;
      }),
      SILHOUETTE_MIN_MAD.y
    );
    items.forEach(function (item, i) {
      var reasons = [];
      if (Math.abs(zArea[i]) >= SILHOUETTE_Z_THRESHOLD) {
        reasons.push(zArea[i] > 0 ? 'área maior que as demais' : 'área menor que as demais');
      }
      if (Math.abs(zCx[i]) >= SILHOUETTE_Z_THRESHOLD) {
        reasons.push(zCx[i] > 0 ? 'deslocada à direita' : 'deslocada à esquerda');
      }
      if (Math.abs(zCy[i]) >= SILHOUETTE_Z_THRESHOLD) {
        reasons.push(zCy[i] > 0 ? 'deslocada para baixo' : 'deslocada para cima');
      }
      if (reasons.length) alerts[item.id] = reasons;
    });
    return alerts;
  }

  /**
   * Área do bbox como fração do próprio quadro da imagem (mesma normalização
   * de silhouetteMetrics), não pixels brutos. Guias são sempre analisadas em
   * mainUrl (largura 1200, mas altura varia por foto), e um upload local usa
   * a resolução nativa do arquivo — comparar área em pixels brutos entre
   * itens de resoluções diferentes inflava/definhava targetArea e fazia
   * autoCorrectScaleMul encolher fotos boas (ex.: upload em alta resolução
   * comparado a guias de 1200px virava um "zoom 66%" artificial).
   *
   * effectiveBbox já é tolerante a sombra por padrão (ver seu comentário),
   * então a área do item sendo corrigido e a dos demais membros do grupo
   * usam o mesmo critério — sem isso o cálculo sub-corrigia quando a foto
   * alvo tinha uma sombra de contato mais forte que as demais (a mediana do
   * grupo ficava artificialmente maior, incluindo a sombra delas).
   */
  function silhouetteAreaOf(item) {
    var bb = effectiveBbox(item);
    var w = item.analysis.w || 1;
    var h = item.analysis.h || 1;
    return Math.max(1e-6, (bb.w * bb.h) / (w * h));
  }

  /**
   * Corrige o zoom (scaleMul) de um item fotografado numa escala diferente
   * dos demais do modelo (câmera mais perto/mais longe) — a detecção de
   * sombra não resolve isso, porque o bbox pode estar correto e mesmo assim
   * maior/menor que o padrão do grupo (ex.: alça avulsa fendi, foto de outra
   * sessão/crop). Usa raiz quadrada da razão de área (largura×altura) contra
   * a mediana dos demais itens, o que escala a foto isotropicamente
   * (preserva a proporção) até o tamanho visual bater com o resto.
   */
  function autoCorrectScaleMul(target) {
    var peers = state.masks.filter(function (m) {
      return m !== target;
    });
    if (peers.length < SILHOUETTE_MIN_ITEMS - 1) return null;
    var peerArea = median(peers.map(silhouetteAreaOf));
    var targetArea = silhouetteAreaOf(target);
    if (!peerArea || !targetArea) return null;
    return clamp(Math.sqrt(peerArea / targetArea), 0.4, 2.5);
  }

  /**
   * Roda uma vez, ao carregar as máscaras de um modelo: itens com silhueta
   * fora do padrão sobem pro topo da lista (fica mais fácil achar o que
   * precisa de ajuste) e já saem destrancados (edição livre num clique, sem
   * precisar destravar manualmente). Não roda de novo a cada render — senão
   * a lista ficaria se reordenando embaixo do usuário enquanto ele edita.
   */
  function prioritizeProblemMasks(masks) {
    var alerts = computeSilhouetteAlerts(masks);
    masks.forEach(function (m) {
      if (alerts[m.id]) m.locked = false;
    });
    masks.sort(function (a, b) {
      return (alerts[b.id] ? 1 : 0) - (alerts[a.id] ? 1 : 0);
    });
    return masks;
  }

  function layerThumbUrl(item) {
    if (!state.lay) return item.product.thumbUrl || '';
    var thumbOpts = { fill: settings.fill, feather: false, featherPx: 0 };
    var thumbScale = scaleToView(itemBaseScale(item), THUMB_W);
    var key = processCacheKey(item, thumbScale, state.lay.bottomGap, thumbOpts, THUMB_W, THUMB_H);
    if (!item._thumbUrls) item._thumbUrls = {};
    if (item._thumbUrls[key]) return item._thumbUrls[key];
    var c = getProcessed(item, thumbScale, state.lay.bottomGap, thumbOpts, THUMB_W, THUMB_H);
    var url = canvasToUrl(c, 0.75);
    item._thumbUrls[key] = url;
    return url;
  }

  function renderLayers() {
    if (!layersEl) return;
    layersEl.innerHTML = '';

    var editTitle = document.createElement('p');
    editTitle.className = 'gm-editor__section-title';
    editTitle.textContent = 'Edição';
    layersEl.appendChild(editTitle);

    var slot = document.createElement('div');
    slot.className =
      'gm-editor__slot' + (state.editable ? ' gm-editor__slot--filled' : '');
    slot.setAttribute('data-gm-editor-slot', '');

    if (state.editable) {
      var ed = state.editable;
      var row = document.createElement('div');
      var editFocused = !state.selectedGuideId;
      row.className =
        'gm-editor__layer gm-editor__layer--editable' +
        (editFocused ? ' gm-editor__layer--selected' : '');
      row.setAttribute('data-gm-editor-focus-editable', '');
      row.setAttribute('role', 'button');
      row.tabIndex = 0;
      row.title = 'Voltar para a camada em edição';
      row.innerHTML =
        '<span class="gm-editor__eye" aria-hidden="true" style="opacity:0.35">' +
        EYE_SVG_ON +
        '</span>' +
        '<img src="' +
        escapeAttr(layerThumbUrl(ed)) +
        '" alt="" width="40" height="53">' +
        '<span class="gm-editor__layer-meta">' +
        '<strong>' +
        escapeAttr(productCaption(ed.product, 'Editável')) +
        '</strong>' +
        '<small>' +
        escapeAttr(ed.source === 'upload' ? 'upload local' : ed.product.handle) +
        '</small></span>' +
        '<button type="button" class="gm-editor__layer-clear" data-gm-editor-clear title="Limpar slot" aria-label="Limpar slot">' +
        '<svg class="gm-editor__ico" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path fill="currentColor" d="M3.2 2.1 7 5.9l3.8-3.8.9.9L7.9 6.8l3.8 3.8-.9.9L7 7.7l-3.8 3.8-.9-.9 3.8-3.8-3.8-3.8.9-.9z"/></svg>' +
        '</button>';
      slot.appendChild(row);
    } else {
      var drop = document.createElement('button');
      drop.type = 'button';
      drop.className = 'gm-editor__slot-drop';
      drop.setAttribute('data-gm-editor-upload', '');
      drop.innerHTML =
        '<svg class="gm-editor__ico" width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" focusable="false">' +
        '<path fill="none" stroke="currentColor" stroke-width="1.5" d="M3 14.5V18h16v-3.5M11 3v11M6.5 7.5 11 3l4.5 4.5"/></svg>' +
        '<strong>Upload de imagem</strong>' +
        '<span>Arraste ou clique para selecionar</span>' +
        '<small class="gm-editor__slot-hint">Tamanho padrão: ' +
        OUT_W +
        '×' +
        OUT_H +
        '</small>';
      slot.appendChild(drop);
    }
    layersEl.appendChild(slot);

    var exportRow = document.createElement('div');
    exportRow.className = 'gm-editor__export-row';

    var exportBtn = document.createElement('button');
    exportBtn.type = 'button';
    exportBtn.className = 'gm-editor__btn gm-editor__btn--accent gm-editor__export';
    exportBtn.setAttribute('data-gm-editor-export', '');
    exportBtn.disabled = !getEditTarget();
    exportBtn.innerHTML =
      '<svg class="gm-editor__ico" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M8 1.5v8.2L5.4 7.1l-.9.9L8 11.5l3.5-3.5-.9-.9L9 9.7V1.5H8zM2.5 13h11v1.5h-11z"/></svg>' +
      'Baixar';
    exportRow.appendChild(exportBtn);
    btnExport = exportBtn;

    var exportAllBtn = document.createElement('button');
    exportAllBtn.type = 'button';
    exportAllBtn.className =
      'gm-editor__btn gm-editor__btn--accent gm-editor__export gm-editor__export--all';
    exportAllBtn.setAttribute('data-gm-editor-export-all', '');
    exportAllBtn.disabled = !state.masks.length;
    exportAllBtn.innerHTML =
      '<svg class="gm-editor__ico" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M8 1.5v8.2L5.4 7.1l-.9.9L8 11.5l3.5-3.5-.9-.9L9 9.7V1.5H8zM2.5 13h11v1.5h-11z"/>' +
      '<path fill="currentColor" d="M11.2 3.2h1.3v1.3H11.2zM13 5h1.3v1.3H13z"/></svg>' +
      'Baixar todas';
    exportRow.appendChild(exportAllBtn);
    layersEl.appendChild(exportRow);

    var guideHead = document.createElement('div');
    guideHead.className = 'gm-editor__section-head';
    var masterOn = state.masksMasterVisible;
    var masterLocked = allMasksLocked();
    guideHead.innerHTML =
      '<span class="gm-editor__layer-toggles">' +
      '<button type="button" class="gm-editor__eye gm-editor__eye--master' +
      (masterOn ? '' : ' is-hidden') +
      '" data-gm-editor-eye-master aria-pressed="' +
      (masterOn ? 'true' : 'false') +
      '" title="Mostrar/ocultar todas as guias"' +
      (!state.modelo || !state.masks.length ? ' disabled' : '') +
      '>' +
      EYE_SVG_ON +
      EYE_SVG_OFF +
      '</button>' +
      '<button type="button" class="gm-editor__lock gm-editor__lock--master' +
      (masterLocked ? ' is-locked' : '') +
      '" data-gm-editor-lock-master aria-pressed="' +
      (masterLocked ? 'true' : 'false') +
      '" title="' +
      (masterLocked ? 'Destrancar todas (edição livre)' : 'Trancar todas (só visual)') +
      '"' +
      (!state.modelo || !state.masks.length ? ' disabled' : '') +
      '>' +
      LOCK_SVG_ON +
      LOCK_SVG_OFF +
      '</button>' +
      '</span>' +
      '<span class="gm-editor__section-title gm-editor__section-title--inline">Camadas guia</span>';
    layersEl.appendChild(guideHead);

    if (!state.masks.length) {
      var empty = document.createElement('p');
      empty.className = 'gm-editor__section-empty';
      empty.textContent = state.modelo
        ? 'Nenhuma guia neste modelo.'
        : 'Escolha um modelo para carregar as guias.';
      layersEl.appendChild(empty);
    }

    var silhouetteAlerts = computeSilhouetteAlerts(state.masks);
    var silhouetteCount = Object.keys(silhouetteAlerts).length;
    if (silhouetteCount) {
      var banner = document.createElement('p');
      banner.className = 'gm-editor__silhouette-banner';
      banner.innerHTML =
        WARN_SVG +
        '<span>' +
        silhouetteCount +
        ' de ' +
        state.masks.length +
        ' fotos com silhueta fora do padrão — confira os itens marcados.</span>';
      layersEl.appendChild(banner);
    }

    state.masks.forEach(function (mask) {
      var mrow = document.createElement('div');
      var isSel = state.selectedGuideId === mask.id;
      var isFree = mask.locked === false;
      var warnReasons = silhouetteAlerts[mask.id];
      mrow.className =
        'gm-editor__layer' +
        (isSel ? ' gm-editor__layer--selected' : '') +
        (isFree ? ' gm-editor__layer--unlocked' : '') +
        (warnReasons ? ' gm-editor__layer--alert' : '');
      mrow.setAttribute('data-gm-editor-select-guide', mask.id);
      mrow.setAttribute('role', 'button');
      mrow.tabIndex = 0;
      var maskEyeOn = mask.visible && state.masksMasterVisible;
      mrow.innerHTML =
        '<span class="gm-editor__layer-toggles">' +
        '<button type="button" class="gm-editor__eye' +
        (maskEyeOn ? '' : ' is-hidden') +
        '" data-gm-editor-eye="' +
        escapeAttr(mask.id) +
        '" aria-pressed="' +
        (mask.visible ? 'true' : 'false') +
        '" title="Mostrar/ocultar máscara">' +
        EYE_SVG_ON +
        EYE_SVG_OFF +
        '</button>' +
        '<button type="button" class="gm-editor__lock' +
        (mask.locked !== false ? ' is-locked' : '') +
        '" data-gm-editor-lock="' +
        escapeAttr(mask.id) +
        '" aria-pressed="' +
        (mask.locked !== false ? 'true' : 'false') +
        '" title="' +
        (mask.locked !== false
          ? 'Destrancar (edição livre ao selecionar)'
          : 'Trancar (só visual)') +
        '">' +
        LOCK_SVG_ON +
        LOCK_SVG_OFF +
        '</button>' +
        '</span>' +
        '<img src="' +
        escapeAttr(layerThumbUrl(mask)) +
        '" alt="" width="40" height="53">' +
        '<span class="gm-editor__layer-meta">' +
        '<strong>' +
        escapeAttr(productCaption(mask.product, '')) +
        '</strong>' +
        '<small>' +
        escapeAttr(mask.product.handle) +
        '</small></span>' +
        (warnReasons
          ? '<span class="gm-editor__layer-warn" title="Ajuste sugerido: ' +
            escapeAttr(warnReasons.join(', ')) +
            '">' +
            WARN_SVG +
            escapeAttr(warnReasons.join(' · ')) +
            '</span>'
          : '') +
        '<span class="gm-editor__layer-actions">' +
        '<button type="button" class="gm-editor__layer-dl" data-gm-editor-dl-mask="' +
        escapeAttr(mask.id) +
        '" title="Baixar com correção automática (1650×2200)" aria-label="Baixar ' +
        escapeAttr(mask.product.handle || mask.id) +
        '">' +
        '<svg class="gm-editor__ico" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path fill="currentColor" d="M5.5 1v5.2L3.7 4.4l-.7.7L6 8.1l3-3-.7-.7L6.5 6.2V1h-1zM2 9h8v1.2H2z"/></svg>' +
        'Baixar</button>' +
        '</span>';
      layersEl.appendChild(mrow);
    });

    syncEyeMaster();
    syncLockMaster();
    setToolsEnabled(!!getEditTarget());
    syncZoomUi();
    syncBboxBtn();
  }

  var BBOX_HANDLE = Math.max(12, Math.round(VIEW_W / 40));

  function bboxScreenRect(lay) {
    var bb = lay.bbox;
    return {
      x: lay.dx + bb.x * lay.scale,
      y: lay.dy + bb.y * lay.scale,
      w: bb.w * lay.scale,
      h: bb.h * lay.scale,
    };
  }

  function hitBboxHandle(sx, sy, rect) {
    var hs = BBOX_HANDLE;
    var nearL = Math.abs(sx - rect.x) <= hs;
    var nearR = Math.abs(sx - (rect.x + rect.w)) <= hs;
    var nearT = Math.abs(sy - rect.y) <= hs;
    var nearB = Math.abs(sy - (rect.y + rect.h)) <= hs;
    var inX = sx >= rect.x - hs && sx <= rect.x + rect.w + hs;
    var inY = sy >= rect.y - hs && sy <= rect.y + rect.h + hs;
    if (nearT && nearL) return 'nw';
    if (nearT && nearR) return 'ne';
    if (nearB && nearL) return 'sw';
    if (nearB && nearR) return 'se';
    if (nearT && inX) return 'n';
    if (nearB && inX) return 's';
    if (nearL && inY) return 'w';
    if (nearR && inY) return 'e';
    return null;
  }

  function drawBboxHandles(ctx, rect) {
    ctx.strokeStyle = 'rgba(27, 200, 117, 1)';
    ctx.lineWidth = 2;
    ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);
    var hs = 8;
    var pts = [
      [rect.x, rect.y],
      [rect.x + rect.w / 2, rect.y],
      [rect.x + rect.w, rect.y],
      [rect.x, rect.y + rect.h / 2],
      [rect.x + rect.w, rect.y + rect.h / 2],
      [rect.x, rect.y + rect.h],
      [rect.x + rect.w / 2, rect.y + rect.h],
      [rect.x + rect.w, rect.y + rect.h],
    ];
    ctx.fillStyle = '#fff';
    ctx.strokeStyle = 'rgba(27, 200, 117, 1)';
    pts.forEach(function (p) {
      ctx.fillRect(p[0] - hs / 2, p[1] - hs / 2, hs, hs);
      ctx.strokeRect(p[0] - hs / 2, p[1] - hs / 2, hs, hs);
    });
  }

  function cursorForHandle(h) {
    if (h === 'n' || h === 's') return 'ns-resize';
    if (h === 'e' || h === 'w') return 'ew-resize';
    if (h === 'ne' || h === 'sw') return 'nesw-resize';
    if (h === 'nw' || h === 'se') return 'nwse-resize';
    return 'default';
  }

  function stageEdgeFill() {
    var item = state.editable;
    if (!item || !item.analysis || !item.analysis.edge) {
      var guides = typeof guideItems === 'function' ? guideItems() : [];
      for (var i = 0; i < guides.length; i++) {
        if (guides[i] && guides[i].analysis && guides[i].analysis.edge) {
          item = guides[i];
          break;
        }
      }
    }
    if (item && item.analysis && item.analysis.edge) {
      var e = item.analysis.edge;
      return 'rgb(' + e.r + ',' + e.g + ',' + e.b + ')';
    }
    return '#f6f6f6';
  }

  function paint() {
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var vw = canvas.width;
    var vh = canvas.height;
    ctx.fillStyle = stageEdgeFill();
    ctx.fillRect(0, 0, vw, vh);

    if (!state.modelo || !state.lay) {
      setHint('Escolha um modelo para carregar as máscaras-guia.');
      return;
    }

    var guideViewScale = scaleToView(state.lay.scale, vw);
    var editViewScale = scaleToView(
      state.lay.editScale != null ? state.lay.editScale : state.lay.scale,
      vw
    );
    var guides = guideItems();
    var drawOpts = { fill: settings.fill, feather: false, featherPx: 0 };
    var guideAlpha = OVERLAY_ALPHA;
    var focusAlpha = guides.length || state.editable ? Math.min(1, OVERLAY_ALPHA + 0.4) : 1;
    var focus = getEditTarget();
    var selectedGuide = null;
    if (state.selectedGuideId) {
      for (var gi = 0; gi < guides.length; gi++) {
        if (guides[gi].id === state.selectedGuideId) {
          selectedGuide = guides[gi];
          break;
        }
      }
      if (!selectedGuide) state.selectedGuideId = null;
    }

    function drawProcessed(item, alpha, viewScale) {
      if (!item) return;
      var c = getProcessed(item, viewScale, state.lay.bottomGap, drawOpts, vw, vh);
      ctx.globalAlpha = alpha;
      ctx.drawImage(c, 0, 0);
    }

    function scaleFor(item) {
      if (item && state.editable && item === state.editable) return editViewScale;
      return guideViewScale;
    }

    // Camadas de fundo (não foco), desenhadas de trás pra frente — a primeira
    // da lista (prioridade: itens com silhueta fora do padrão, ver
    // prioritizeProblemMasks) fica desenhada por último, ou seja, por cima
    // das demais guias, em vez de ficar soterrada embaixo delas.
    for (var bgi = guides.length - 1; bgi >= 0; bgi--) {
      var bgItem = guides[bgi];
      if (focus && bgItem === focus) continue;
      if (selectedGuide && bgItem === selectedGuide && !(focus && focus === selectedGuide)) {
        continue;
      }
      drawProcessed(bgItem, guideAlpha, guideViewScale);
    }
    if (state.editable && state.editable !== focus) {
      drawProcessed(state.editable, guideAlpha, editViewScale);
    }
    // Destaque visual de guia trancada (só overlay)
    if (selectedGuide && selectedGuide.locked !== false && selectedGuide !== focus) {
      drawProcessed(selectedGuide, focusAlpha, guideViewScale);
    }
    // Foco de edição (livre ou slot)
    if (focus) {
      drawProcessed(focus, focusAlpha, scaleFor(focus));
    }

    ctx.globalAlpha = 1;
    if (state.bboxMode && focus) {
      var layF = layoutParams(focus, scaleFor(focus), state.lay.bottomGap, vw, vh);
      drawBboxHandles(ctx, bboxScreenRect(layF));
      setHint('Refinar área: alças redimensionam a caixa de alinhamento.');
    } else if (focus && focus !== state.editable) {
      setHint('Edição livre · pan/zoom nesta guia · tranca pra só visual');
    } else if (selectedGuide && selectedGuide.locked !== false) {
      setHint('Guia trancada (só visual). Destranca ou use upload.');
    } else if (focus) {
      setHint(
        guides.length
          ? 'Editável · guias por baixo · destranca guia pra edição livre'
          : 'Drag = pan · Scroll = zoom · nenhuma guia visível'
      );
    } else {
      setHint(
        selectedGuide
          ? 'Guia em destaque. Destranca ou faça upload pra editar.'
          : 'Faça upload ou destranca uma guia (edição livre).'
      );
    }

    ctx.globalAlpha = 1;
    var guideY = vh * (1 - state.lay.bottomGap);
    ctx.strokeStyle = 'rgba(255, 60, 60, 0.65)';
    ctx.setLineDash([5, 4]);
    ctx.beginPath();
    ctx.moveTo(0, guideY);
    ctx.lineTo(vw, guideY);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  /**
   * Se a seleção atual é só destaque visual (trancada), limpa pra focar o slot.
   * Guia destrancada permanece como alvo de edição livre.
   */
  function clearLockedGuideHighlight() {
    if (!state.selectedGuideId) return false;
    var m = findMaskById(state.selectedGuideId);
    if (m && m.locked === false) return false;
    state.selectedGuideId = null;
    renderLayers();
    return true;
  }

  function refreshAll() {
    refreshLay();
    renderLayers();
    syncBboxBtn();
    paint();
  }

  function downloadCanvas(c, filename) {
    return new Promise(function (resolve) {
      c.toBlob(
        function (blob) {
          if (!blob) {
            resolve(false);
            return;
          }
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            URL.revokeObjectURL(a.href);
            a.remove();
            resolve(true);
          }, 200);
        },
        'image/jpeg',
        0.95
      );
    });
  }

  function buildHiExportItem(loItem) {
    if (loItem.source === 'upload' || !loItem.product.mainUrlHi) {
      return Promise.resolve({
        product: loItem.product,
        analysis: loItem.analysis,
        edit: {
          scaleMul: (loItem.edit && loItem.edit.scaleMul) || 1,
          offsetX: (loItem.edit && loItem.edit.offsetX) || 0,
          offsetY: (loItem.edit && loItem.edit.offsetY) || 0,
          bboxOverride: loItem.edit && loItem.edit.bboxOverride
            ? {
                x: loItem.edit.bboxOverride.x,
                y: loItem.edit.bboxOverride.y,
                w: loItem.edit.bboxOverride.w,
                h: loItem.edit.bboxOverride.h,
              }
            : null,
        },
        _sameRes: true,
      });
    }
    var url = loItem.product.mainUrlHi || loItem.product.mainUrl;
    return loadImage(url).then(function (img) {
      var analysis = analyzeImage(img);
      var sx = analysis.w / loItem.analysis.w;
      var sy = analysis.h / loItem.analysis.h;
      var loBbox =
        loItem.edit && loItem.edit.bboxOverride
          ? loItem.edit.bboxOverride
          : loItem.analysis.bbox;
      analysis.edge = {
        r: loItem.analysis.edge.r,
        g: loItem.analysis.edge.g,
        b: loItem.analysis.edge.b,
      };
      return {
        product: loItem.product,
        analysis: analysis,
        edit: {
          scaleMul: (loItem.edit && loItem.edit.scaleMul) || 1,
          offsetX: (loItem.edit && loItem.edit.offsetX) || 0,
          offsetY: (loItem.edit && loItem.edit.offsetY) || 0,
          bboxOverride: scaleBbox(loBbox, sx, sy),
        },
      };
    });
  }

  function exportItemProcessed(loItem, loScale) {
    if (!loItem || !state.lay) {
      return Promise.reject(new Error('Sem layout'));
    }
    var bottomGap = state.lay.bottomGap;
    var opts = {
      fill: settings.fill,
      feather: settings.feather,
      featherPx: settings.featherPx,
      showBbox: false,
    };
    return buildHiExportItem(loItem).then(function (hiItem) {
      var scale = hiItem._sameRes
        ? loScale
        : scaleFromPreview(loScale, loItem.analysis, hiItem.analysis);
      var c = processTo34(hiItem, scale, bottomGap, opts, OUT_W, OUT_H);
      var name = (hiItem.product.handle || 'foto') + '-main.jpg';
      return downloadCanvas(c, name).then(function (ok) {
        return { ok: ok, name: name };
      });
    });
  }

  function exportEditable() {
    var target = getEditTarget();
    if (!target || !state.lay) {
      alert('Selecione uma camada editável (destrancada ou slot) para baixar.');
      return;
    }
    var loScale = itemBaseScale(target);
    setHint('Baixando ' + OUT_W + '×' + OUT_H + '…');
    exportItemProcessed(target, loScale)
      .then(function (res) {
        setHint('Baixado · ' + res.name);
        setStatus('Baixado ' + OUT_W + '×' + OUT_H);
      })
      .catch(function (err) {
        console.error(err);
        setHint('Falha no download.');
        alert('Falha ao baixar imagem.');
      });
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function exportAllMasks() {
    if (!state.lay || !state.masks.length) {
      alert('Escolha um modelo com guias para baixar todas.');
      return;
    }
    var list = state.masks.slice();
    var loScale = state.lay.scale;
    var ok = 0;
    var fail = 0;
    var btn = section.querySelector('[data-gm-editor-export-all]');
    if (btn) btn.disabled = true;
    setHint('Baixando todas · 0/' + list.length + '…');
    setStatus('Baixando todas…');

    list
      .reduce(function (chain, item, ix) {
        return chain.then(function () {
          setHint('Baixando todas · ' + (ix + 1) + '/' + list.length + '…');
          return exportItemProcessed(item, loScale)
            .then(function () {
              ok += 1;
            })
            .catch(function (err) {
              console.error(err);
              fail += 1;
            })
            .then(function () {
              return delay(350);
            });
        });
      }, Promise.resolve())
      .then(function () {
        if (btn) btn.disabled = !state.masks.length;
        setHint(
          'Baixadas ' +
            ok +
            '/' +
            list.length +
            (fail ? ' · ' + fail + ' falha(s)' : '')
        );
        setStatus(
          'Baixadas ' + ok + ' · ' + OUT_W + '×' + OUT_H + ' · correção automática'
        );
      });
  }

  function downloadMask(maskId) {
    if (!state.lay) {
      alert('Escolha um modelo antes de baixar.');
      return;
    }
    var loItem = null;
    for (var i = 0; i < state.masks.length; i++) {
      if (state.masks[i].id === maskId) {
        loItem = state.masks[i];
        break;
      }
    }
    if (!loItem) return;
    setHint('Baixando ' + (loItem.product.handle || maskId) + '…');
    exportItemProcessed(loItem, state.lay.scale)
      .then(function (res) {
        setHint('Baixado · ' + res.name);
        setStatus('Baixado ' + OUT_W + '×' + OUT_H + ' · correção automática');
      })
      .catch(function (err) {
        console.error(err);
        setHint('Falha no download.');
        alert('Falha ao baixar imagem.');
      });
  }

  function clearEditable() {
    if (state.editable && state.editable.objectUrl) {
      try {
        URL.revokeObjectURL(state.editable.objectUrl);
      } catch (e) {}
    }
    if (state.editable && state.editable.source === 'mask') {
      var restored = state.editable;
      restored.edit = { scaleMul: 1, offsetX: 0, offsetY: 0, bboxOverride: null };
      restored.visible = true;
      restored._procCache = {};
      restored._thumbUrls = {};
      state.masks.unshift(restored);
    }
    state.editable = null;
    state.selectedGuideId = null;
    state.bboxMode = false;
    if (canvas) canvas.style.cursor = 'default';
    refreshAll();
  }

  function setEditable(item) {
    if (state.editable && state.editable.objectUrl && state.editable !== item) {
      try {
        URL.revokeObjectURL(state.editable.objectUrl);
      } catch (e) {}
    }
    state.editable = item;
    ensureEdit(item);
    state.selectedGuideId = null;
    state.bboxMode = false;
    if (canvas) canvas.style.cursor = 'grab';
    refreshAll();
  }

  function ingestFile(file) {
    if (!file || !file.type || file.type.indexOf('image/') !== 0) {
      alert('Selecione um arquivo de imagem.');
      return;
    }
    if (state.editable && state.editable.source === 'mask') {
      clearEditable();
    } else if (state.editable && state.editable.objectUrl) {
      try {
        URL.revokeObjectURL(state.editable.objectUrl);
      } catch (e) {}
      state.editable = null;
    }
    var objectUrl = URL.createObjectURL(file);
    var baseName = (file.name || 'upload').replace(/\.[^.]+$/, '');
    var product = {
      handle: baseName.replace(/\s+/g, '-').toLowerCase() || 'upload',
      title: file.name || 'Upload',
      cor: file.name || 'Upload',
      modelo: state.modelo || '_upload',
      mainUrl: objectUrl,
      mainUrlHi: objectUrl,
      thumbUrl: objectUrl,
      cardUrl: objectUrl,
    };
    loadImage(objectUrl)
      .then(function (img) {
        var analysis = analyzeImage(img);
        var item = makeItem(product, img, analysis, {
          id: 'upload-' + Date.now(),
          source: 'upload',
          objectUrl: objectUrl,
        });
        setEditable(item);
        setStatus('Upload · ' + product.title);
      })
      .catch(function () {
        URL.revokeObjectURL(objectUrl);
        alert('Falha ao carregar a imagem.');
      });
  }

  function analyzeProducts(list) {
    return Promise.all(
      list.map(function (p) {
        return loadImage(p.mainUrl)
          .then(function (img) {
            return makeItem(p, img, analyzeImage(img), {
              id: p.handle,
              source: 'mask',
            });
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (results) {
      return results.filter(Boolean);
    });
  }

  function selectModelo(modeloKey) {
    if (!modeloKey) return;
    closeModeloModal();

    if (state.editable && state.editable.source === 'upload' && state.editable.objectUrl) {
      try {
        URL.revokeObjectURL(state.editable.objectUrl);
      } catch (e) {}
    }
    state.editable = null;
    state.selectedGuideId = null;
    state.bboxMode = false;
    state.masksMasterVisible = true;
    state.modelo = modeloKey;

    var label = modeloDisplayName(modeloKey);
    for (var li = 0; li < modeloCatalog.length; li++) {
      if (modeloCatalog[li].modelo === modeloKey) {
        label = modeloCatalog[li].label || label;
        break;
      }
    }
    if (modeloLabel) modeloLabel.textContent = label;

    if (analyzedByModelo[modeloKey] && analyzedByModelo[modeloKey].length) {
      state.masks = analyzedByModelo[modeloKey].map(function (it) {
        return {
          id: it.id,
          product: it.product,
          img: it.img,
          analysis: it.analysis,
          visible: true,
          locked: it.locked !== false,
          source: 'mask',
          objectUrl: null,
          edit: { scaleMul: 1, offsetX: 0, offsetY: 0, bboxOverride: null },
          _procCache: {},
          _thumbUrls: {},
        };
      });
      // Cache antigo sem locked → tranca por padrão
      state.masks.forEach(function (m) {
        if (m.locked == null) m.locked = true;
      });
      prioritizeProblemMasks(state.masks);
      setStatus(state.masks.length + ' máscaras · ' + label);
      refreshAll();
      return;
    }

    var entry = null;
    for (var i = 0; i < modeloCatalog.length; i++) {
      if (modeloCatalog[i].modelo === modeloKey) {
        entry = modeloCatalog[i];
        break;
      }
    }
    if (!entry) return;

    state.masks = [];
    refreshAll();
    var token = ++loadToken;
    setStatus('Carregando ' + entry.products.length + ' mains…');
    setHint('Analisando máscaras do modelo…');

    analyzeProducts(entry.products).then(function (results) {
      if (token !== loadToken || state.modelo !== modeloKey) return;
      analyzedByModelo[modeloKey] = results;
      state.masks = results;
      prioritizeProblemMasks(state.masks);
      var failed = entry.products.length - results.length;
      setStatus(
        results.length +
          ' máscaras' +
          (failed ? ' · ' + failed + ' falha(s)' : '') +
          ' · ' +
          label
      );
      refreshAll();
    });
  }

  function isModeloModalOpen() {
    if (!modeloModal) return false;
    return !!modeloModal.open || modeloModal.hasAttribute('open');
  }

  /**
   * Quantos itens desse modelo estão com silhueta fora do padrão (spec 0082).
   * null = ainda não analisado (lazy-load não rodou pra esse modelo).
   */
  function modeloProblemCount(modeloKey) {
    var items = analyzedByModelo[modeloKey];
    if (!items) return null;
    return Object.keys(computeSilhouetteAlerts(items)).length;
  }

  /**
   * Varre os modelos ainda não analisados em background (um de cada vez, pra
   * não estourar a rede) só pra saber quantos itens têm silhueta suspeita —
   * assim o picker mostra "N fora do padrão" antes mesmo de abrir o modelo. Só
   * dispara uma vez por sessão, a partir da primeira abertura do modal.
   */
  var modeloScanStarted = false;
  function scanModelosForAlerts() {
    if (modeloScanStarted) return;
    modeloScanStarted = true;
    var queue = modeloCatalog.filter(function (entry) {
      return entry.products.length >= SILHOUETTE_MIN_ITEMS && !analyzedByModelo[entry.modelo];
    });
    queue.reduce(function (chain, entry) {
      return chain.then(function () {
        if (analyzedByModelo[entry.modelo]) return null;
        return analyzeProducts(entry.products).then(function (results) {
          analyzedByModelo[entry.modelo] = results;
          if (isModeloModalOpen()) {
            renderModeloList((modeloSearch && modeloSearch.value) || '');
          }
        });
      });
    }, Promise.resolve());
  }

  function openModeloModal() {
    if (!modeloModal) return;
    renderModeloList((modeloSearch && modeloSearch.value) || '');
    if (typeof modeloModal.showModal === 'function') modeloModal.showModal();
    else modeloModal.setAttribute('open', '');
    if (modeloSearch) {
      modeloSearch.focus();
      modeloSearch.select();
    }
    scanModelosForAlerts();
  }

  function closeModeloModal() {
    if (!modeloModal) return;
    if (typeof modeloModal.close === 'function') modeloModal.close();
    else modeloModal.removeAttribute('open');
  }

  function modeloMetaHtml(entry) {
    var countStr =
      entry.products.length + ' cor' + (entry.products.length === 1 ? '' : 'es');
    var problems = modeloProblemCount(entry.modelo);
    if (!problems) return escapeAttr(countStr);
    return (
      escapeAttr(countStr) +
      '<span class="gm-editor__modelo-divider" aria-hidden="true"></span>' +
      '<span class="gm-editor__modelo-warn">' +
      WARN_SVG +
      problems +
      ' fora do padrão</span>'
    );
  }

  function renderModeloList(query) {
    if (!modeloList) return;
    var q = String(query || '')
      .trim()
      .toLowerCase();
    var prevScroll = modeloList.scrollTop;
    modeloList.innerHTML = '';
    var filtered = modeloCatalog.filter(function (entry) {
      if (!q) return true;
      var label = (entry.label || entry.modelo || '').toLowerCase();
      var key = (entry.modelo || '').toLowerCase();
      return label.indexOf(q) >= 0 || key.indexOf(q) >= 0;
    });
    if (!filtered.length) {
      modeloList.innerHTML =
        '<p class="gm-editor__hint" style="padding:12px">Nenhum modelo encontrado.</p>';
      return;
    }
    filtered.forEach(function (entry) {
      var label = entry.label || modeloDisplayName(entry);
      var problems = modeloProblemCount(entry.modelo);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'gm-editor__modelo-item' +
        (state.modelo === entry.modelo ? ' gm-editor__modelo-item--active' : '') +
        (problems ? ' gm-editor__modelo-item--alert' : '');
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-gm-editor-pick-modelo', entry.modelo);
      btn.innerHTML =
        '<img src="' +
        escapeAttr(entry.thumb) +
        '" alt="" width="48" height="64" loading="lazy">' +
        '<span><strong>' +
        escapeAttr(label) +
        '</strong><small>' +
        modeloMetaHtml(entry) +
        '</small></span>';
      modeloList.appendChild(btn);
    });
    modeloList.scrollTop = prevScroll;
  }

  function applyPanDelta(dx, dy) {
    var target = getEditTarget();
    if (!target) return;
    clearLockedGuideHighlight();
    target = getEditTarget();
    if (!target) return;
    var ed = ensureEdit(target);
    ed.offsetX += dx;
    ed.offsetY += dy;
    paint();
    renderLayers();
  }

  function applyZoomFactor(factor) {
    var target = getEditTarget();
    if (!target) return;
    clearLockedGuideHighlight();
    target = getEditTarget();
    if (!target) return;
    var ed = ensureEdit(target);
    ed.scaleMul = clamp(ed.scaleMul * factor, 0.4, 2.5);
    syncZoomUi();
    paint();
    renderLayers();
  }

  function setZoomAbsolute(pct) {
    var target = getEditTarget();
    if (!target) return;
    clearLockedGuideHighlight();
    target = getEditTarget();
    if (!target) return;
    ensureEdit(target).scaleMul = clamp(pct / 100, 0.4, 2.5);
    paint();
    renderLayers();
  }

  function bindUi() {
    if (btnOpenModelo) btnOpenModelo.addEventListener('click', openModeloModal);
    if (btnModeloClose) btnModeloClose.addEventListener('click', closeModeloModal);
    if (modeloModal) {
      modeloModal.addEventListener('click', function (e) {
        if (e.target === modeloModal) closeModeloModal();
      });
    }
    if (modeloSearch) {
      modeloSearch.addEventListener('input', function () {
        renderModeloList(modeloSearch.value);
      });
    }
    if (modeloList) {
      modeloList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gm-editor-pick-modelo]');
        if (!btn) return;
        selectModelo(btn.getAttribute('data-gm-editor-pick-modelo'));
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        if (file) ingestFile(file);
        fileInput.value = '';
      });
    }

    if (layersEl) {
      layersEl.addEventListener('click', function (e) {
        var exportClick = e.target.closest('[data-gm-editor-export]');
        if (exportClick) {
          exportEditable();
          return;
        }
        var exportAllClick = e.target.closest('[data-gm-editor-export-all]');
        if (exportAllClick) {
          exportAllMasks();
          return;
        }
        var masterBtn = e.target.closest('[data-gm-editor-eye-master]');
        if (masterBtn) {
          state.masksMasterVisible = !state.masksMasterVisible;
          renderLayers();
          paint();
          return;
        }
        var lockMasterBtn = e.target.closest('[data-gm-editor-lock-master]');
        if (lockMasterBtn) {
          var unlockAll = allMasksLocked();
          state.masks.forEach(function (m) {
            m.locked = !unlockAll;
          });
          setToolsEnabled(!!getEditTarget());
          syncZoomUi();
          renderLayers();
          paint();
          return;
        }
        var clearBtn = e.target.closest('[data-gm-editor-clear]');
        if (clearBtn) {
          clearEditable();
          return;
        }
        var focusEdit = e.target.closest('[data-gm-editor-focus-editable]');
        if (focusEdit) {
          state.selectedGuideId = null;
          setToolsEnabled(!!getEditTarget());
          syncZoomUi();
          renderLayers();
          paint();
          return;
        }
        var uploadBtn = e.target.closest('[data-gm-editor-upload]');
        if (uploadBtn && fileInput) {
          fileInput.click();
          return;
        }
        var eyeBtn = e.target.closest('[data-gm-editor-eye]');
        if (eyeBtn) {
          var id = eyeBtn.getAttribute('data-gm-editor-eye');
          state.masks.forEach(function (m) {
            if (m.id === id) m.visible = !m.visible;
          });
          renderLayers();
          paint();
          return;
        }
        var lockBtn = e.target.closest('[data-gm-editor-lock]');
        if (lockBtn) {
          var lid = lockBtn.getAttribute('data-gm-editor-lock');
          state.masks.forEach(function (m) {
            if (m.id === lid) m.locked = !(m.locked !== false);
          });
          var unlocked = findMaskById(lid);
          if (unlocked && unlocked.locked === false) {
            state.selectedGuideId = lid;
            state.masksMasterVisible = true;
            unlocked.visible = true;
          }
          setToolsEnabled(!!getEditTarget());
          syncZoomUi();
          renderLayers();
          paint();
          return;
        }
        var dlMaskBtn = e.target.closest('[data-gm-editor-dl-mask]');
        if (dlMaskBtn) {
          e.stopPropagation();
          downloadMask(dlMaskBtn.getAttribute('data-gm-editor-dl-mask'));
          return;
        }
        var guideRow = e.target.closest('[data-gm-editor-select-guide]');
        if (guideRow) {
          var gid = guideRow.getAttribute('data-gm-editor-select-guide');
          if (state.selectedGuideId === gid) {
            state.selectedGuideId = null;
          } else {
            state.selectedGuideId = gid;
            state.masksMasterVisible = true;
            state.masks.forEach(function (m) {
              if (m.id === gid) {
                m.visible = true;
              }
            });
          }
          setToolsEnabled(!!getEditTarget());
          syncZoomUi();
          if (canvas) {
            canvas.style.cursor =
              getEditTarget() && !state.bboxMode ? 'grab' : 'default';
          }
          renderLayers();
          paint();
        }
      });

      layersEl.addEventListener('dragover', function (e) {
        var slot = e.target.closest('[data-gm-editor-slot]');
        if (!slot || state.editable) return;
        e.preventDefault();
        slot.classList.add('is-dragover');
      });
      layersEl.addEventListener('dragleave', function (e) {
        var slot = e.target.closest('[data-gm-editor-slot]');
        if (slot) slot.classList.remove('is-dragover');
      });
      layersEl.addEventListener('drop', function (e) {
        var slot = e.target.closest('[data-gm-editor-slot]');
        if (!slot) return;
        e.preventDefault();
        slot.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) ingestFile(file);
      });
    }

    if (btnAutoAlign) {
      // Ação de disparo único (não é modo): recalcula a silhueta descartando
      // sombra e aplica como bboxOverride desta camada. Pra desfazer, usa
      // Resetar — o botão em si não guarda estado "ligado".
      btnAutoAlign.addEventListener('click', function () {
        var target = getEditTarget();
        if (!target) return;
        clearLockedGuideHighlight();
        target = getEditTarget();
        if (!target) return;
        var ed = ensureEdit(target);
        ed.bboxOverride = shadowAwareBbox(target);
        var mul = autoCorrectScaleMul(target);
        ed.scaleMul = mul != null ? mul : 1;
        ed.offsetX = 0;
        ed.offsetY = 0;
        target._procCache = {};
        target._thumbUrls = {};
        // bboxOverride entra no cálculo da escala compartilhada do grupo
        // (sharedScaleForGroup) — sem refazer state.lay aqui, só a posição
        // (dx/dy) atualiza e o item nunca muda de tamanho na tela.
        refreshLay();
        syncZoomUi();
        paint();
        renderLayers();
      });
    }

    if (btnBbox) {
      btnBbox.addEventListener('click', function () {
        if (!getEditTarget()) return;
        clearLockedGuideHighlight();
        state.bboxMode = !state.bboxMode;
        if (canvas) canvas.style.cursor = state.bboxMode ? 'default' : 'grab';
        syncBboxBtn();
        paint();
      });
    }

    if (btnCenter) {
      btnCenter.addEventListener('click', function () {
        var target = getEditTarget();
        if (!target) return;
        clearLockedGuideHighlight();
        target = getEditTarget();
        if (!target) return;
        ensureEdit(target).offsetX = 0;
        paint();
        renderLayers();
      });
    }

    if (btnReset) {
      btnReset.addEventListener('click', function () {
        var target = getEditTarget();
        if (!target) return;
        clearLockedGuideHighlight();
        target = getEditTarget();
        if (!target) return;
        target.edit = { scaleMul: 1, offsetX: 0, offsetY: 0, bboxOverride: null };
        target._procCache = {};
        target._thumbUrls = {};
        refreshLay();
        syncZoomUi();
        paint();
        renderLayers();
      });
    }

    if (zoomInp) {
      zoomInp.addEventListener('input', function () {
        if (zoomOut) zoomOut.textContent = zoomInp.value + '%';
        setZoomAbsolute(Number(zoomInp.value));
      });
    }

    if (!canvas) return;

    canvas.addEventListener(
      'wheel',
      function (e) {
        if (!getEditTarget() || state.bboxMode) return;
        e.preventDefault();
        var factor = e.deltaY < 0 ? 1.04 : 0.96;
        applyZoomFactor(factor);
      },
      { passive: false }
    );

    canvas.addEventListener('pointerdown', function (e) {
      if (!getEditTarget()) return;
      if (clearLockedGuideHighlight()) paint();
      var target = getEditTarget();
      if (!target) return;
      canvas.setPointerCapture(e.pointerId);
      var rect = canvas.getBoundingClientRect();
      var sx = ((e.clientX - rect.left) / rect.width) * canvas.width;
      var sy = ((e.clientY - rect.top) / rect.height) * canvas.height;

      if (state.bboxMode) {
        if (!state.lay) return;
        var vScale = scaleToView(itemBaseScale(target), canvas.width);
        var lay = layoutParams(
          target,
          vScale,
          state.lay.bottomGap,
          canvas.width,
          canvas.height
        );
        var screen = bboxScreenRect(lay);
        var handle = hitBboxHandle(sx, sy, screen);
        if (!handle) return;
        var bb = lay.bbox;
        state.bboxDrag = {
          item: target,
          handle: handle,
          startX: sx,
          startY: sy,
          orig: { x: bb.x, y: bb.y, w: bb.w, h: bb.h },
          scale: lay.scale,
        };
        return;
      }

      state.drag = { x: e.clientX, y: e.clientY };
    });

    canvas.addEventListener('pointermove', function (e) {
      var target = getEditTarget();
      if (!target) {
        return;
      }

      if (state.bboxDrag) {
        var bd = state.bboxDrag;
        var rect = canvas.getBoundingClientRect();
        var sx = ((e.clientX - rect.left) / rect.width) * canvas.width;
        var sy = ((e.clientY - rect.top) / rect.height) * canvas.height;
        var ddx = (sx - bd.startX) / bd.scale;
        var ddy = (sy - bd.startY) / bd.scale;
        var o = bd.orig;
        var minSize = 20;
        var maxW = bd.item.analysis.w;
        var maxH = bd.item.analysis.h;
        var nx = o.x;
        var ny = o.y;
        var nw = o.w;
        var nh = o.h;
        var h = bd.handle;

        if (h.indexOf('w') >= 0) {
          nx = Math.round(o.x + ddx);
          nw = Math.round(o.w - ddx);
        }
        if (h.indexOf('e') >= 0) nw = Math.round(o.w + ddx);
        if (h.indexOf('n') >= 0) {
          ny = Math.round(o.y + ddy);
          nh = Math.round(o.h - ddy);
        }
        if (h.indexOf('s') >= 0) nh = Math.round(o.h + ddy);

        if (nw < minSize) {
          if (h.indexOf('w') >= 0) nx = o.x + o.w - minSize;
          nw = minSize;
        }
        if (nh < minSize) {
          if (h.indexOf('n') >= 0) ny = o.y + o.h - minSize;
          nh = minSize;
        }
        if (nx < 0) {
          nw += nx;
          nx = 0;
        }
        if (ny < 0) {
          nh += ny;
          ny = 0;
        }
        if (nx + nw > maxW) nw = maxW - nx;
        if (ny + nh > maxH) nh = maxH - ny;
        if (nw < minSize) nw = minSize;
        if (nh < minSize) nh = minSize;

        ensureEdit(bd.item).bboxOverride = { x: nx, y: ny, w: nw, h: nh };
        paint();
        return;
      }

      if (state.bboxMode) {
        if (!state.lay) return;
        var r2 = canvas.getBoundingClientRect();
        var sx2 = ((e.clientX - r2.left) / r2.width) * canvas.width;
        var sy2 = ((e.clientY - r2.top) / r2.height) * canvas.height;
        var vScale2 = scaleToView(itemBaseScale(target), canvas.width);
        var lay2 = layoutParams(
          target,
          vScale2,
          state.lay.bottomGap,
          canvas.width,
          canvas.height
        );
        var handle2 = hitBboxHandle(sx2, sy2, bboxScreenRect(lay2));
        canvas.style.cursor = handle2 ? cursorForHandle(handle2) : 'default';
        return;
      }

      if (state.drag) {
        canvas.style.cursor = 'grabbing';
        var scaleX = OUT_W / canvas.getBoundingClientRect().width;
        var scaleY = OUT_H / canvas.getBoundingClientRect().height;
        var dx = (e.clientX - state.drag.x) * scaleX;
        var dy = (e.clientY - state.drag.y) * scaleY;
        state.drag.x = e.clientX;
        state.drag.y = e.clientY;
        applyPanDelta(dx, dy);
        return;
      }

      canvas.style.cursor = 'grab';
    });

    canvas.addEventListener('pointerup', function () {
      var hadBboxDrag = !!state.bboxDrag;
      state.bboxDrag = null;
      state.drag = null;
      if (hadBboxDrag) {
        // Só recalcula a escala compartilhada ao soltar — refazer a cada
        // pointermove pesaria o arraste sem necessidade.
        refreshLay();
        paint();
        renderLayers();
      }
    });
  }

  function boot() {
    resolveProductModelos(products, modelosCatalog);
    if (!products.length) {
      setStatus('Nenhum produto com featured_image.');
      setHint('Cadastre produtos com imagem principal.');
      return;
    }
    modeloCatalog = buildModeloCatalog();
    bindUi();
    setStatus(modeloCatalog.length + ' modelos · escolha um para começar');
    renderLayers();
    paint();
  }

  setStatus('Carregando produtos…');
  if (window.GmPhotoCatalog) {
    window.GmPhotoCatalog.load().then(function (catalog) {
      products = window.GmPhotoCatalog.merge(products, catalog, window.GmPhotoCatalog.mapEditor);
      boot();
    });
  } else {
    boot();
  }
})();
